// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"775":"20902857","977":"c880d587"}[chunkId] + ".css";
};